import { render } from "./AddBookingPage.vue?vue&type=template&id=389113f2&scoped=true"
import script from "./AddBookingPage.vue?vue&type=script&lang=js"
export * from "./AddBookingPage.vue?vue&type=script&lang=js"

import "./AddBookingPage.vue?vue&type=style&index=0&id=389113f2&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/gestionale-simba-2.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-389113f2"]])

export default __exports__